// extracted by mini-css-extract-plugin
export var centerText = "_gx-8";
export var container = "_gx-0";
export var doughnutContainer = "_gx-7";
export var legend = "_gx-a";
export var legendItemColorDisplay = "_gx-b";
export var legendItemLabel = "_gx-d";
export var legendItemValue = "_gx-c";
export var lg = "_gx-5";
export var maxWidth = "_gx-9";
export var md = "_gx-4";
export var responsive = "_gx-6";
export var sm = "_gx-3";
export var xs = "_gx-2";
export var xxs = "_gx-1";